import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ProofingService from "../services/proofingService";

// Add Proofing Start
const defaultAddProofingState = {
  addProofingLoading: false,
  addProofingData: null,
  addProofingError: null,
};

const addProofingData = createAsyncThunk("proofing/add", async (payload) => {
  return await ProofingService.createProofing(payload);
});

const addProofingReducer = createSlice({
  name: "addProofingData",
  initialState: defaultAddProofingState,
  extraReducers: (builder) => {
    builder.addCase(addProofingData.pending, (state) => {
      state.addProofingLoading = true;
    });
    builder.addCase(addProofingData.fulfilled, (state, action) => {
      state.addProofingLoading = false;
      state.addProofingData = action.payload;
      state.addProofingError = "";
    });
    builder.addCase(addProofingData.rejected, (state, action) => {
      state.addProofingLoading = false;
      state.addProofingData = null;
      state.addProofingError = action.error.message;
    });
  },
});

export const AddProofingReducer = addProofingReducer.reducer;
export const AddProofingData = addProofingData;
// Add Proofing End

// Update Proofing Start
const updateProofingState = {
  updateProofingLoading: false,
  updateProofingData: null,
  updateProofingError: null,
};

const updateProofing = createAsyncThunk("proofing/update", async (payload) => {
  return await ProofingService.updateProofing(payload);
});

const updateProofingReducer = createSlice({
  name: "updateProofingReducer",
  initialState: updateProofingState,
  extraReducers: (builder) => {
    builder.addCase(updateProofing.pending, (state) => {
      state.updateProofingLoading = true;
    });
    builder.addCase(updateProofing.fulfilled, (state, action) => {
      state.updateProofingLoading = false;
      state.updateProofingData = action.payload;
      state.updateProofingError = "";
    });
    builder.addCase(updateProofing.rejected, (state, action) => {
      state.updateProofingLoading = false;
      state.updateProofingData = null;
      state.updateProofingError = action.error.message;
    });
  },
});

export const UpdateProofingReducer = updateProofingReducer.reducer;
export const UpdateProofing = updateProofing;
//Update Proofing End

// Get Proofing Data List Start
const defaultProofingListData = {
  getProofingListLoading: false,
  getProofingListData: null,
  getProofingListError: null,
};

const fetchProofingList = createAsyncThunk(
  "proofing/proofingList",
  async (payload) => {
    return await ProofingService.getProofingList(payload);
  },
);

const getProofingListReducer = createSlice({
  name: "getProofingListData",
  initialState: defaultProofingListData,
  extraReducers: (builder) => {
    builder.addCase(fetchProofingList.pending, (state) => {
      state.getProofingListLoading = true;
    });
    builder.addCase(fetchProofingList.fulfilled, (state, action) => {
      state.getProofingListLoading = false;
      state.getProofingListData = action.payload;
      state.getProofingListError = "";
    });
    builder.addCase(fetchProofingList.rejected, (state, action) => {
      state.getProofingListLoading = false;
      state.getProofingListData = null;
      state.getProofingListError = action.error.message;
    });
  },
});

export const GetProofingListReducer = getProofingListReducer.reducer;
export const FetchProofingList = fetchProofingList;
// Get Proofing Data List End

// Send To Proofing Start
const sendToProofingState = {
  sendToProofingLoading: false,
  sendToProofing: null,
  sendToProofingError: null,
};

const sendToProofing = createAsyncThunk(
  "proofing/sendToProofing",
  async (payload) => {
    return await ProofingService.sendToProofing(payload);
  },
);

const sendToProofingReducer = createSlice({
  name: "sendToProofing",
  initialState: sendToProofingState,
  extraReducers: (builder) => {
    builder.addCase(sendToProofing.pending, (state) => {
      state.sendToProofingLoading = true;
    });
    builder.addCase(sendToProofing.fulfilled, (state, action) => {
      state.sendToProofingLoading = false;
      state.sendToProofing = action.payload;
      state.sendToProofingError = "";
    });
    builder.addCase(sendToProofing.rejected, (state, action) => {
      state.sendToProofingLoading = false;
      state.sendToProofing = null;
      state.sendToProofingError = action.error.message;
    });
  },
});

export const SendToProofingReducer = sendToProofingReducer.reducer;
export const SendToProofing = sendToProofing;
// Send To Proofing End

// Get Spirit List Associate Proofing Start
const getSpiritListAssociateProofingState = {
  getSpiritListAssociateProofingLoading: false,
  getSpiritListAssociateProofingData: null,
  getSpiritListAssociateProofingError: null,
};

const getSpiritListAssociateProofing = createAsyncThunk(
  "proofing/getSpiritListAssociateProofing",
  async (payload) => {
    return await ProofingService.getSpiritListAssociateProofing(payload);
  },
);

const getSpiritListAssociateProofingReducer = createSlice({
  name: "getSpiritListAssociateProofing",
  initialState: getSpiritListAssociateProofingState,
  extraReducers: (builder) => {
    builder.addCase(getSpiritListAssociateProofing.pending, (state) => {
      state.getSpiritListAssociateProofingLoading = true;
    });
    builder.addCase(
      getSpiritListAssociateProofing.fulfilled,
      (state, action) => {
        state.getSpiritListAssociateProofingLoading = false;
        state.getSpiritListAssociateProofingData = action.payload;
        state.getSpiritListAssociateProofingError = "";
      },
    );
    builder.addCase(
      getSpiritListAssociateProofing.rejected,
      (state, action) => {
        state.getSpiritListAssociateProofingLoading = false;
        state.getSpiritListAssociateProofingData = null;
        state.getSpiritListAssociateProofingError = action.error.message;
      },
    );
  },
});

export const GetSpiritListAssociateProofingReducer =
  getSpiritListAssociateProofingReducer.reducer;
export const GetSpiritListAssociateProofing = getSpiritListAssociateProofing;
// Get Spirit List Associate Proofing End

// Unlink Spirit With Proofing Start
const unlinkSpiritWithProofingState = {
  unlinkSpiritWithProofingLoading: false,
  unlinkSpiritWithProofingData: null,
  unlinkSpiritWithProofingError: null,
};

const unlinkSpiritWithProofing = createAsyncThunk(
  "proofing/unlinkSpiritWithProofing",
  async (payload) => {
    return await ProofingService.unlinkSpiritWithProofing(payload);
  },
);

const unlinkSpiritWithProofingReducer = createSlice({
  name: "unlinkSpiritWithProofing",
  initialState: unlinkSpiritWithProofingState,
  extraReducers: (builder) => {
    builder.addCase(unlinkSpiritWithProofing.pending, (state) => {
      state.unlinkSpiritWithProofingLoading = true;
    });
    builder.addCase(unlinkSpiritWithProofing.fulfilled, (state, action) => {
      state.unlinkSpiritWithProofingLoading = false;
      state.unlinkSpiritWithProofingData = action.payload;
      state.unlinkSpiritWithProofingError = "";
    });
    builder.addCase(unlinkSpiritWithProofing.rejected, (state, action) => {
      state.unlinkSpiritWithProofingLoading = false;
      state.unlinkSpiritWithProofingData = null;
      state.unlinkSpiritWithProofingError = action.error.message;
    });
  },
});

export const UnlinkSpiritWithProofingReducer =
  unlinkSpiritWithProofingReducer.reducer;
export const UnlinkSpiritWithProofing = unlinkSpiritWithProofing;
// Unlink Spirit With Proofing End

// Delete Proofing Sub Log Start
const deleteProofingLogState = {
  deleteProofingLogLoading: false,
  deleteProofingLogData: null,
  deleteProofingLogError: null,
};

const deleteProofingLog = createAsyncThunk("proofing/delete", async (payload) => {
  return await ProofingService.deleteProofing(payload);
});

const deleteProofingLogReducer = createSlice({
  name: "deleteProofingLogReducer",
  initialState: deleteProofingLogState,
  extraReducers: (builder) => {
    builder.addCase(deleteProofingLog.pending, (state) => {
      state.deleteProofingLogLoading = true;
    });
    builder.addCase(deleteProofingLog.fulfilled, (state, action) => {
      state.deleteProofingLogLoading = false;
      state.deleteProofingLogData = action.payload;
      state.deleteProofingLogError = "";
    });
    builder.addCase(deleteProofingLog.rejected, (state, action) => {
      state.deleteProofingLogLoading = false;
      state.deleteProofingLogData = null;
      state.deleteProofingLogError = action.error.message;
    });
  },
});

export const DeleteProofingLogReducer = deleteProofingLogReducer.reducer;
export const DeleteProofingLog = deleteProofingLog;